import { render, staticRenderFns } from "./behaviorAnalysis.vue?vue&type=template&id=bb1aba74&"
import script from "./behaviorAnalysis.vue?vue&type=script&lang=js&"
export * from "./behaviorAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./behaviorAnalysis.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports